import collapseService from '../collapse/collapse.service';
import objectService from '../object/object.service';

export default function sectionService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    engineApi.options = engineApi.options || {};
    const isOptimize = engineApi.options.optimize === true || engineApi.options.optimize === 'true';

    return generateElement().addAttribute('ng-form', viewField.name || 'NONAME');

    function generateElement() {
      if (!viewField.isCollapse) {
        return objectService()(viewField, engineApi);
      }
      if (!isOptimize) {
        return collapseService()(viewField, engineApi);
      }

      // generamos el template del collapse (sin el contenido)
      const template = engineApi.register
        .setCommonAttributes('ec-collapse', viewField, engineApi)
        .addAttribute('opened', viewField.metadata.open === true || viewField.metadata.open === 'true')
        .addAttribute('section-optimize', viewField.name) // usado para encontrar las secciones (en frontend también)
        .addAttribute(
          'ng-init',
          `
          vm.toggleSection['${viewField.name}'] = ${viewField.metadata.open};
          vm.isSectionInViewPort['${viewField.name}'] = ${viewField.metadata.open};
          vm.isSectionOpened['${viewField.name}'] = ${viewField.metadata.open};
        `
        )
        .addAttribute('is-opened', `vm.isSectionOpened['${viewField.name}']`)
        .addAttribute('toggle', ` vm.toggleSection['${viewField.name}'] `).setHtml(`
          <header>
            <ec-toolbar>
              <label>${viewField.title || ''}</label>
              <ec-space></ec-space>
              ${viewField.metadata.toolbar ? engineApi.handleProperties(viewField.metadata.toolbar, engineApi).reduce((acc, cur) => acc + cur.toString(), '') : ''}
            </ec-toolbar>
          </header>
          <main>
            <ec-flex-rows fb-compile="vm.isSectionInViewPort['${viewField.name}'] && vm.isSectionOpened['${viewField.name}']" fb-compile-name="${viewField.name}"></ec-flex-rows>
          </main>
      `);

      // @odeniel OJO que el handleProperties debe ejecutarse despues del setCommonAttributes:

      // almacenamos el template en el formBuilderApi para compilarlo con fb-compile solo cuando hace falta
      engineApi.sections[viewField.name] = engineApi.handleProperties(viewField, engineApi).reduce((acc, cur) => acc + cur.toString(), '');

      return template;
    }
  };
}
